module.exports = __webpack_public_path__ + "img/dashiji-1999.de3808be.jpg";